// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"08ad69b6","732":"5e7b4b79","977":"cf70abe0"}[chunkId] + ".chunk.js";
};